module.exports = __webpack_public_path__ + "assets/img/player_pause.fe6f859b.png";